module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'detail'
  }, [(_vm.showCutscenes) ? _c('Cutscenes') : _vm._e(), _vm._v(" "), _c('DownloadNav', {
    attrs: {
      "ifShow": _vm.ifShow
    }
  }), _vm._v(" "), _c('div', {
    class: 'detail-content'
  }, [(_vm.poData && _vm.poData.images.length && !_vm.isVideo) ? _c('div', {
    staticClass: "swipe-box"
  }, [_c('Swipe', {
    staticClass: "swipe-content",
    attrs: {
      "showIndicators": false,
      "auto": 0,
      "continuous": false
    },
    on: {
      "change": _vm.handleChange
    }
  }, _vm._l((_vm.poData.images), function(item, index) {
    return _c('SwipeItem', {
      key: item.url,
      attrs: {
        "alt": index
      }
    }, [_c('div', {
      staticClass: "carouse-item",
      style: (("background-image:url(" + (item.hd_url) + ")"))
    })])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "post-info-bottom"
  }, [_c('div', {
    staticClass: "post-info-left"
  }, [_c('div', {
    staticClass: "likers"
  }, _vm._l((_vm.poData.praise), function(item, index) {
    return (index < 3) ? _c('img', {
      key: index,
      staticClass: "likers-avatar",
      attrs: {
        "src": item.face,
        "alt": "",
        "srcset": ""
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), (parseInt(_vm.poData.praise_count) != 0) ? _c('span', [_vm._v(_vm._s(_vm.poData.praise_count) + "赞")]) : _vm._e(), _vm._v(" "), (parseInt(_vm.poData.collect_count) != 0) ? _c('span', [_vm._v(_vm._s(_vm.poData.collect_count) + "收藏")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "post-info-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.poData.views) + "阅读")])])]), _vm._v(" "), (_vm.poData.images.length > 1) ? _c('span', {
    staticClass: "indicators"
  }, [_vm._v(_vm._s(_vm.poData.images.length > 1 ? _vm.swipeIndex + 1 : 1) + "/" + _vm._s(_vm.poData.images.length))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.poData && _vm.isVideo) ? _c('div', {
    class: 'video ' + (_vm.playing ? 'full' : '')
  }, [_c('video', {
    ref: "video",
    attrs: {
      "webkit-playsinline": "",
      "playsinline": "",
      "x5-playsinline": "",
      "x-webkit-airplay": "allow",
      "poster": _vm.poData.images[0].url,
      "src": _vm.poData.images[1].url
    },
    on: {
      "click": _vm.playVideo,
      "ended": _vm.ended
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "video-btn",
    attrs: {
      "hidden": _vm.playing
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.playVideo($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "post-info-bottom"
  }, [_c('div', {
    staticClass: "post-info-left"
  }, [_c('div', {
    staticClass: "likers"
  }, _vm._l((_vm.poData.praise), function(item, index) {
    return (index < 3) ? _c('img', {
      key: index,
      staticClass: "likers-avatar",
      attrs: {
        "src": item.face,
        "alt": "",
        "srcset": ""
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), _c('span', [_vm._v(_vm._s(parseInt(_vm.poData.praise_count)) + "赞")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(parseInt(_vm.poData.collect_count)) + "收藏")])]), _vm._v(" "), _c('div', {
    staticClass: "post-info-right"
  }, [_c('span', [_vm._v(_vm._s(_vm.poData.views) + "阅读")])])])]) : _vm._e(), _vm._v(" "), (_vm.poData) ? _c('div', {
    staticClass: "post-info"
  }, [_c('div', {
    staticClass: "post-user"
  }, [_c('div', {
    staticClass: "post-user-left"
  }, [_c('img', {
    staticClass: "user-avatar",
    attrs: {
      "src": _vm.poData.user.face,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('span', {
    class: 'user-nickname ' + 'sex_' + _vm.poData.user.gender
  }, [_vm._v(_vm._s(_vm.poData.user.username))]), _vm._v(" "), _c('span', {
    staticClass: "user-po-time"
  }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(_vm.poData.dateline)))])]), _vm._v(" "), _c('div', {
    staticClass: "post-identity"
  }, [_vm._l((_vm.poData.user.icons), function(item, index) {
    return _c('img', {
      key: index,
      staticClass: "post-medal",
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), _vm._v(" "), _vm._l((_vm.poData.user.medals), function(item, index) {
    return _c('img', {
      key: item.medal_id,
      staticClass: "post-medal",
      attrs: {
        "src": item.medal_icon,
        "alt": index
      }
    })
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "post-user-right"
  }, [(_vm.poData.tag.tag_stick || _vm.poData.sticker) ? _c('img', {
    staticClass: "po-sticker",
    attrs: {
      "src": _vm.poData.tag.tag_stick || _vm.poData.sticker,
      "alt": ""
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "post-content"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.poData.tag && _vm.poData.tag.tag_id),
      expression: "poData.tag && poData.tag.tag_id"
    }],
    staticClass: "tag",
    on: {
      "click": function($event) {
        return _vm.toTag(_vm.poData.tag.tag_id)
      }
    }
  }, [_vm._v("#" + _vm._s(_vm.poData.tag.tag_name))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.contentFilters(_vm.poData.content))
    }
  })]), _vm._v(" "), (_vm.poData.labels.length != 0) ? _c('div', {
    staticClass: "post-tags"
  }, [_c('span', {
    staticClass: "tag-icon margin"
  }), _vm._v(" "), _vm._l((_vm.poData.labels), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "tag margin",
      on: {
        "click": function($event) {
          return _vm.toLabel(item.label_id)
        }
      }
    }, [_vm._v(_vm._s(item.label_name))])
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.poData && _vm.poData.comments.length) ? _c('div', {
    staticClass: "comments"
  }, [
    [_c('div', {
      staticClass: "comment-list"
    }, _vm._l((_vm.poData.comments), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "comment-item"
      }, [_c('div', {
        staticClass: "line"
      }), _vm._v(" "), _c('div', {
        staticClass: "user_info"
      }, [_c('div', {
        staticClass: "user_info_left"
      }, [_c('div', {
        staticClass: "avatar",
        style: ('background-image:url(' + item.cuinfo.face + ')')
      }), _vm._v(" "), _c('p', {
        staticClass: "user_name"
      }, [_c('span', {
        class: 'nick sex_' + item.cuinfo.gender
      }, [_vm._v(_vm._s(item.cuinfo.username))]), _vm._v(" "), (item.ruinfo.uid) ? _c('span', [_vm._v("\n                    回复\n                    "), _c('span', {
        class: 'nick sex_' + item.ruinfo.gender
      }, [_vm._v(_vm._s(item.ruinfo.username))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
        staticClass: "time"
      }, [_vm._v(_vm._s(_vm._f("timestamp2txt")(item.dateline)))])]), _vm._v(" "), _c('p', {
        staticClass: "comment-txt",
        domProps: {
          "innerHTML": _vm._s(item.comment)
        }
      })])
    }), 0)]
  ], 2) : _vm._e(), _vm._v(" "), (parseInt(_vm.poData.comment_count) > 0 && _vm.from_admin == 0) ? _c('div', {
    staticClass: "all-comments",
    on: {
      "click": _vm.downApp
    }
  }, [(parseInt(_vm.poData.comment_count) > 3) ? _c('div', {
    staticClass: "check-all-comments"
  }, [_vm._v("\n        打开西子湖畔App 查看全部" + _vm._s(parseInt(_vm.poData.comment_count)) + "条评论\n      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hotList.length > 0 && _vm.from_admin == 0) ? _c('div', {
    staticClass: "tab_content",
    attrs: {
      "id": "tab_content"
    }
  }, [_c('h1', [_vm._v("话题相关")]), _vm._v(" "), _c('div', {
    staticClass: "water_fall"
  }, [_c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_0"
  }, _vm._l((_vm.waterFall.col_0), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [(item.views != 0) ? _c('div', {
      staticClass: "read_count"
    }, [_vm._v("\n                " + _vm._s(item.views) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.hd_url) + ");height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), (parseInt(item.praise_count) != 0) ? _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(parseInt(item.praise_count)))])]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col_wrap"
  }, [_c('div', {
    ref: "col_1"
  }, _vm._l((_vm.waterFall.col_1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function($event) {
          return _vm.jumpPoDetail(item.id)
        }
      }
    }, [(item.views != 0) ? _c('div', {
      staticClass: "read_count"
    }, [_vm._v("\n                " + _vm._s(item.views) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "img",
      style: (("background-image:url(" + (item.cover.hd_url) + ");height:" + (item.cover.h) + "px;width:" + (item.cover.w) + "px;"))
    }, [(item.type == 2) ? _c('div', {
      staticClass: "mask"
    }, [_c('div', {
      staticClass: "video-btn"
    })]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "desc",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "user_n_time"
    }, [_c('div', {
      staticClass: "user-info"
    }, [_c('img', {
      staticClass: "user_avatar",
      attrs: {
        "src": item.user.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      class: 'username sex_' + item.user.gender
    }, [_vm._v(_vm._s(item.user.username))])]), _vm._v(" "), (item.praise_count != 0) ? _c('div', {
      staticClass: "praise-content"
    }, [_c('span', {
      staticClass: "praise-icon"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.praise_count))])]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('p', {
    staticClass: "upload-tips",
    on: {
      "click": function($event) {
        return _vm.openApp(_vm.noMoreData)
      }
    }
  }, [_vm._v("\n        " + _vm._s(!_vm.noMoreData ?
    !_vm.loaded ?
    "正在加载中" :
    "上拉加载更多哦" :
    "啊哦加载完了，打开app查看更多有趣的话题吧") + "~\n      ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.playing),
      expression: "!playing"
    }],
    staticClass: "bottom-panel"
  }, [_c('div', {
    staticClass: "fake-input",
    on: {
      "click": _vm.downApp
    }
  }, [_vm._v("赞是喜欢，评论是爱")]), _vm._v(" "), _c('div', {
    staticClass: "operations"
  }, [_c('div', {
    class: ("like " + (_vm.poData.is_praise == 1 ? 'liked' : '')),
    on: {
      "click": _vm.onZan
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "collection",
    on: {
      "click": _vm.downApp
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-ebb05dfa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/pages/newDetail/newDetail.vue
// module id = 127
// module chunks = 1